import * as yup from 'yup';

function ranking(formatMessage) {
  return yup
    .number()
    .typeError(
      formatMessage({
        id: 'RANKING_FIELD_TYPE_ERROR',
        defaultMessage: 'Ranking cannot be empty',
      }),
    )
    .required(
      formatMessage({
        id: 'RANKING_FIELD_IS_REQUIRED',
        defaultMessage: 'Ranking is required',
      }),
    )
    .min(
      1,
      formatMessage({
        id: 'RANKING_FIELD_MIN',
        defaultMessage: 'Ranking must be at least 1',
      }),
    )
    .max(
      5,
      formatMessage({
        id: 'RANKING_FIELD_MAX',
        defaultMessage: 'Ranking must be at most 5',
      }),
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      ranking: ranking(formatMessage),
    })
    .required();

export default validationSchema;
